Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-request-offer');

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);

        if ($wrapper.length < 1)
            return;

        var $search = $('.x-request-offer-search', $wrapper);
        var $searchInput = $('.js-keyword', $search);
        var $searchList = $('.x-request-offer-search-list', $search);

        var $offerGrid = $('.x-offer-product-grid', $wrapper);
        var $offerPL = $('.x-offer-product-list', $offerGrid);
        var $submitOfferBtn = $('.js-submit-offer', $wrapper);
        var $errorWrapper = $('.js-generic-error', $wrapper);

        var searchModel = null, minLength = $search.data('min-search-length'), userOfferModel, isLookupCompleted = false, currentOfferId = null, selectedProduct = {}, selectedBox, selectedQuantity;

        var texts = {
            ContentProviderCodeText: $offerPL.data('brandcode'),
            CodeText: $offerPL.data('code'),
            ProductTitleText: $offerPL.data('product'),
            BrandNameText: $offerPL.data('brand'),
            CategoryText: $offerPL.data('category'),
            QuantityText: $offerPL.data('quantity'),
            ColorText: $offerPL.data('color'),
            SizeText: $offerPL.data('size'),
            EmptyListMessage: $offerPL.data('noproduct')
        };

        $search.loading = function (loading) {
            isLookupCompleted = !loading;
            if (loading) {
                $search.addClass('x-loading').addClass('x-disabled');
            } else {
                $search.removeClass('x-loading').removeClass('x-disabled');
            };
        };

        $search.show = function (show) {
            if (show) {
                $('html').addClass('no-scroll');
                $search.addClass('js-visible');
            } else {
                $('html').removeClass('no-scroll');
                $search.removeClass('js-visible');
            };
        };

        $searchList.update = function () {
            $search.loading(true);

            var html = Vendd.Handlebars.parse("requestOfferResultProductList", searchModel.data);
            $searchList.html(html);

            initCustomScrollbar($('.result-list-wrapper', $searchList));
            $search.loading(false);
        };

        $searchInput.on('keyup', $.debounce(850, function () {
            var searchTerm = $searchInput.val();
            if (searchTerm.length >= minLength) {
                $search.loading(true);
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.RequestOffer.Messages.SearchForProducts(searchTerm));
            } else {
                $search.show(false);
            }
        }));

        $searchInput.click(function () {
            if ($searchInput.val().length >= minLength && isLookupCompleted) {
                $search.show(true);
            }
        });

        $('.js-close-search-btn', $search).click(function () {
            $search.show(false);
        });

        $('.js-search-overlay', $search).click(function () {
            $search.show(false);
        });

        $searchList.on('click', '.js-add-to-list', function () {
            var $item = $(this);
            var skuIndex = $(this).closest('li').index();
            var pdIndex = $item.closest('.js-list-item').index();

            selectedProduct.Items = [];
            selectedProduct.Texts = texts;
            selectedProduct.Items.push(_.clone(searchModel.data.RequestOfferSearchItems[pdIndex]));
            var selectedSku = _.clone(selectedProduct.Items[0].requestOfferSkuItems[skuIndex]);

            selectedProduct.Items[0].requestOfferSkuItems = [];
            selectedProduct.Items[0].requestOfferSkuItems.push(selectedSku);

            var model = {
                RequestForOfferId: currentOfferId,
                Status: 1,
                AddRequestOfferItems: [{
                    ProductId: selectedProduct.Items[0].ProductId,
                    RequestForOfferItemId: null,
                    SkuId: selectedSku.ProductItemId,
                    ContentProviderCode: null,
                    ProductName: null,
                    BrandTitle: null,
                    ManufacturerId: null,
                    Quantity: 1,
                }]
            }
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.AddOfferProducts(model));
        });

        $offerPL.addProduct = function (selectedProduct) {

            var $html = Vendd.Handlebars.parse(Handlebars.partials.offerProductList, selectedProduct);
            var $list = $('.offer-list-wrapper > ul', $offerPL);
            var product = $('>li .x-offer-product-box[data-offeritemid=' + selectedProduct.Items[0].RequestForOfferItemId + ']', $list);

            if (product.length > 0) {
                var quantity = parseInt($('.js-quantity', product).val()) + 1;

                $('.js-quantity', product).val(quantity);
            } else {
                var $boxes = $('.x-offer-product-box', $html);
                var lastItem = $list.children().last();
                var items = wrapBoxes($boxes, lastItem);

                $list.append(items);
            }
        };

        $offerPL.updatePL = function (model) {
            if (model && model.Items && _.size(model.Items) > 0) {
                $('.button-container', $wrapper).removeClass('disabled');
                $('.button-container .js-submit-offer', $wrapper).removeClass('disabled').removeAttr('disabled');
            } else {
                $('.button-container', $wrapper).addClass('disabled');
                $('.button-container .js-submit-offer', $wrapper).addClass('disabled').attr('disabled', '');
            }
            $offerGrid.removeClass('x-loading');

            var html = Vendd.Handlebars.parse("offerProductList", model);
            $offerPL.html(html);
        };

        $offerPL.on('blur', '.js-quantity', function () {
            var $field = $(this);
            selectedBox = $field.closest('.x-offer-product-box');
            selectedQuantity = parseInt($field.val(), 10);

            if (!selectedQuantity || selectedQuantity < 1) {
                selectedQuantity = 1;
            }

            var model = {
                RequestForOfferId: currentOfferId,
                UpdateRequestOfferItems: [{
                    RequestOfferItemId: selectedBox.data('offeritemid'),
                    Quantity: selectedQuantity
                }]
            };

            $offerGrid.addClass('x-loading');
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.UpdateRequestOfferProducts(model));
        });

        $offerPL.on('click', '.js-decrement', function (event) {
            var $this = $(this);
            var $field = $this.siblings('.js-quantity');
            var step = 1;

            selectedBox = $(this).closest('.x-offer-product-box');
            selectedQuantity = parseInt($field.val(), 10);

            if (!selectedQuantity || selectedQuantity < 1) {
                selectedQuantity = 1;
            } else {
                if (selectedQuantity > step && selectedQuantity % step === 0) {
                    selectedQuantity -= step;
                } else {
                    return;
                }
            }

            $offerGrid.addClass('x-loading');

            var model = {
                RequestForOfferId: currentOfferId,
                UpdateRequestOfferItems: [{
                    RequestOfferItemId: selectedBox.data('offeritemid'),
                    Quantity: selectedQuantity
                }]
            };

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.UpdateRequestOfferProducts(model));
        });

        $offerPL.on('click', '.js-increment', function (event) {
            var $this = $(this);
            var $field = $this.siblings('.js-quantity');
            var step = 1, numberlength, maxLength = parseInt($('.js-quantity', $offerPL).attr('maxlength'));

            selectedBox = $(this).closest('.x-offer-product-box');
            selectedQuantity = parseInt($field.val(), 10);

            if (!selectedQuantity || selectedQuantity < 1) {
                selectedQuantity = 1;
            } else {
                selectedQuantity += step;
                numberlength = Math.log(selectedQuantity) * Math.LOG10E + 1 | 0;
                if (numberlength > maxLength)
                    selectedQuantity -= step;
            }

            $offerGrid.addClass('x-loading');

            var model = {
                RequestForOfferId: currentOfferId,
                UpdateRequestOfferItems: [{
                    RequestOfferItemId: selectedBox.data('offeritemid'),
                    Quantity: selectedQuantity
                }]
            };

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.UpdateRequestOfferProducts(model));
        });

        $offerPL.on('click', '.js-delete', function () {
            selectedBox = $(this).closest('.x-offer-product-box');

            var model = {
                RequestForOfferId: currentOfferId,
                DeleteRequestOfferItems: [{
                    RequestOfferItemId: selectedBox.data('offeritemid'),
                }]
            };

            $offerGrid.addClass('x-loading');
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.DeleteRequestOffer(model));
        });

        $submitOfferBtn.on('click', function () {
            $offerGrid.addClass('x-loading');

            var model = {
                RequestOfferId: currentOfferId,
                Status: 2
            };

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.SubmitRequestOffer(model));
        });

        $offerPL.GetRequestSuccess = function (envelope) {
            var response = envelope.message.data;

            $offerGrid.removeClass('x-loading');

            userOfferModel = {};
            userOfferModel.Texts = texts;

            if (response.RequestForOfferId)
                currentOfferId = response.RequestForOfferId;

            if (response.RequestOfferSearchItems[0]) {
                userOfferModel.Items = [];
                userOfferModel.Items = response.RequestOfferSearchItems;
            }

            $offerPL.updatePL(userOfferModel);
        };

        $offerPL.GetRequestFailure = function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $offerGrid.removeClass('x-loading');
                $offerPL.resetErrors();
                $offerPL.showError(response, "get");

                userOfferModel = {};
                userOfferModel.Texts = texts;
                $offerPL.updatePL(userOfferModel);
            }

        };

        $offerPL.AddProductSuccess = function (envelope) {

            if (envelope.message.data.RequestForOfferId) currentOfferId = envelope.message.data.RequestForOfferId;

            selectedProduct.Items[0].RequestForOfferItemId = envelope.message.data.RequestOfferItemId;

            if ($('.offer-list-wrapper > ul', $offerPL).length > 0) {
                $offerPL.addProduct(selectedProduct);
            } else {
                $offerPL.updatePL(selectedProduct);
            }
        };

        $offerPL.AddProductFailure = function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $offerGrid.removeClass('x-loading');
                $offerPL.resetErrors();
                $offerPL.showError(response, "add");
            }
        };

        $offerPL.UpdateSuccess = function (envelope) {
            var response = envelope.message.data;

            $offerGrid.removeClass('x-loading');

            if (response.Success) {
                $('.js-quantity', selectedBox).val(selectedQuantity);
            } else {
                $offerPL.resetErrors();
                $offerPL.showError(response, "update");
            }
        };

        $offerPL.UpdateFailure = function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $offerGrid.removeClass('x-loading');
                $offerPL.resetErrors();
                $offerPL.showError(response, "update");
            }
        };

        $offerPL.DeleteSuccess = function (envelope) {
            var response = envelope.message.data;

            $offerGrid.removeClass('x-loading');

            if (response.Success) {
                if (selectedBox.closest('li').siblings().length > 0) {
                    selectedBox.closest('li').remove();
                } else {
                    userOfferModel = {};
                    userOfferModel.Texts = texts;

                    $offerPL.updatePL(userOfferModel);
                }
            } else {
                $offerPL.resetErrors();
                $offerPL.showError(response, "delete");
            }
        };

        $offerPL.DeleteFailure = function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $offerGrid.removeClass('x-loading');
                $offerPL.resetErrors();
                $offerPL.showError(response, "delete");
            }
        };

        $offerPL.SubmitSuccess = function (envelope) {
            var response = envelope.message.data;

            $offerGrid.removeClass('x-loading');

            if (response.Success) {
                $('.js-content', $wrapper).hide();
                $('.js-success', $wrapper).addClass('js-visible');
            } else {
                $offerPL.resetErrors();
                $offerPL.showError(response, "submit");
            }
        };

        $offerPL.SubmitFailure = function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $offerGrid.removeClass('x-loading');
                $offerPL.resetErrors();
                $offerPL.showError(response, "submit");
            }
        };

        $offerPL.resetErrors = function () {
            $errorWrapper.removeClass('js-visible');
            $errorWrapper.children().removeClass('js-visible');
        };

        $offerPL.showError = function (response, action) {
            if (response.responseJSON.message) {
                $errorWrapper.children('.service-message').html(response.responseJSON.message).addClass('js-visible');
            } else {
                if (action === "submit") $errorWrapper.children('.submit').addClass('js-visible');
                if (action === "delete") $errorWrapper.children('.delete').addClass('js-visible');
                if (action === "update") $errorWrapper.children('.update').addClass('js-visible');
                if (action === "add") $errorWrapper.children('.add').addClass('js-visible');
                if (action === "get") $errorWrapper.children('.get').addClass('js-visible');
            }

            $errorWrapper.addClass('js-visible');
        };

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SearchForProductsSuccess, wrapper, function (envelope) {
            searchModel = envelope.message.data.model;
            if (searchModel.sender != wrapper) {
                return;
            }
            $searchList.update();
            $search.show(true);
        });

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SearchForProductsFailed, wrapper, function (envelope) {
            var response = envelope.message.data;

            if (response.status == 401) {
                window.location.href = window.location.href;
            } else {
                $search.show(false);
                $search.loading(false);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.GetPendingRequestsOfferSuccess, wrapper, $offerPL.GetRequestSuccess);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.GetPendingRequestsOfferFailure, wrapper, $offerPL.GetRequestFailure);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.AddOfferProductsSuccess, wrapper, $offerPL.AddProductSuccess);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.AddOfferProductsFailure, wrapper, $offerPL.AddProductFailure);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.UpdateRequestOfferProductsSuccess, wrapper, $offerPL.UpdateSuccess);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.UpdateRequestOfferProductsFailure, wrapper, $offerPL.UpdateFailure);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.DeleteRequestOfferSuccess, wrapper, $offerPL.DeleteSuccess);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.DeleteRequestOfferFailure, wrapper, $offerPL.DeleteFailure);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SubmitRequestOfferSuccess, wrapper, $offerPL.SubmitSuccess);

        Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SubmitRequestOfferFailure, wrapper, $offerPL.SubmitFailure);

        Vendd.MessageBus.publishAsync($wrapper, new Vendd.RequestOffer.Messages.GetPendingRequestsOffer(currentOfferId ? currentOfferId : 'null', 9999, 1));
    });

    function initCustomScrollbar(container) {
        if (isTouch()) return;

        if (!container.hasClass('scroll-initialized')) {
            $(container).mCustomScrollbar({
                scrollbarPosition: "inside",
                scrollInertia: 400,
                timeout: 1000,
                theme: "light",
                mouseWheel: { preventDefault: true }
            });
            container.addClass('scroll-initialized');
        }
    }

    function wrapBoxes($boxes, lastItem) {
        var items = [], currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "index" + currentIndex;
            cssClass += (currentIndex % 2) ? " odd" : " even";
            cssClass += (i === $boxes.length - 1) ? " last" : "";

            li.append($boxes.eq(i))
                .addClass(cssClass)
                .attr('data-index', currentIndex);

            items.push(li);

            currentIndex++;
        };

        return items;
    };
});